import { render } from "./ClientUpdatePhoto.vue?vue&type=template&id=7d589f98&scoped=true"
import script from "./ClientUpdatePhoto.vue?vue&type=script&lang=js"
export * from "./ClientUpdatePhoto.vue?vue&type=script&lang=js"

import "./ClientUpdatePhoto.vue?vue&type=style&index=0&id=7d589f98&scoped=true&lang=css"

import exportComponent from "C:\\docker\\bene_piscinas_front_end\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d589f98"]])

export default __exports__